// *******************************************************************************
// Legal person form validation
// *******************************************************************************

const axiosCompanyData = (
  taxNumber,
  companyNameInput,
  companyTaxPayerInput,
  companyAddressInput,
  companyPostCodeInput,
  companyCityInput,
  saopIdInput,
) => {
  companyNameInput.setAttribute('placeholder', 'Preverjam podatke ...');

  const formDataInput = new FormData();
  formDataInput.append('action', 'getCompanyData');
  formDataInput.append('tax_number', taxNumber);
  formDataInput.append('lang', localData.lang);
  formDataInput.append('id', localData.id);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200 && response.data.data.existing === true) {
        companyNameInput.value = response.data.data.name;
        companyAddressInput.value = response.data.data.address;
        companyPostCodeInput.value = response.data.data.postalCode;
        companyCityInput.value = response.data.data.city;
        if (response.data.data.taxPayer === '1') {
          companyTaxPayerInput.setAttribute('checked', true);
        } else {
          companyTaxPayerInput.removeAttribute('checked');
        }
        saopIdInput.value = response.data.data.saopId;
      } else {
        companyNameInput.value = '';
        companyNameInput.setAttribute('placeholder', 'Podjetje s to davčno številko še ni vpisano.');
        companyAddressInput.value = '';
        companyPostCodeInput.value = '';
        companyCityInput.value = '';
        companyTaxPayerInput.removeAttribute('checked');
        saopIdInput.value = '';
      }
      companyNameInput.closest('.mod-input').classList.toggle('is-disabled', response.data.data.existing);
      companyAddressInput.closest('.mod-input').classList.toggle('is-disabled', response.data.data.existing);
      companyPostCodeInput.closest('.mod-input').classList.toggle('is-disabled', response.data.data.existing);
      companyCityInput.closest('.mod-input').classList.toggle('is-disabled', response.data.data.existing);
      companyTaxPayerInput.closest('.checkbox').classList.toggle('is-disabled', response.data.data.existing);
    })
    .catch((err) => {
      console.log(err);
    });
};

const taxNumberInputChecker = (formClassName, inputsIdNames) => {
  const vatNumberInput = formClassName.querySelector(inputsIdNames[6]);
  let currentTaxNumber = '';
  vatNumberInput.addEventListener('focusout', () => {
    const inputTaxNumber = vatNumberInput.value.replace(/\D/g, '') || '';
    if (currentTaxNumber !== inputTaxNumber) {
      currentTaxNumber = inputTaxNumber;
      const inputs = inputsIdNames.map((id) => formClassName.querySelector(id));
      axiosCompanyData(currentTaxNumber, ...inputs);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const legalPersonForm = document.getElementById('legal-person-form');

  if (legalPersonForm) {
    const inputsIdNames = [
      '#company_company_name',
      '#taxpayer',
      '#company_billing_address_1',
      '#company_billing_postcode',
      '#company_billing_city',
      '#saop_id',
      '#company_number',
    ];
    taxNumberInputChecker(legalPersonForm, inputsIdNames);

    const axiosRegisterAction = (formData) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, {action: formData.legal_action}).then((token) => {
          const formErrorMessage = legalPersonForm.querySelector('.form-error-message');
          formErrorMessage.classList.remove('is-validation-failed');
          formErrorMessage.innerHTML = formErrorMessage.getAttribute('data-generic-error-message');
          const formDataInput = new FormData();
          formDataInput.append('action', formData.legal_action);
          formDataInput.append('inputs', JSON.stringify(formData));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('token', token);
          axios
            .post(localData.siteURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200) {
                window.location.replace(response.data.data.url);
              }
            })
            .catch((err) => {
              formErrorMessage.innerHTML = err.response.data.data.msg;
              formErrorMessage.classList.add('is-validation-failed');
            });
        });
      });
    };

    let message1 = '';
    let message2 = '';
    if (legalPersonForm.querySelector('[name="company_signup_password"]')) {
      message1 = legalPersonForm.querySelector('[name="company_signup_password"]').getAttribute('data-error-message');
      message2 = legalPersonForm.querySelector('[name="company_signup_confirm_password"]').getAttribute('data-error-message');
    }

    const fv = FormValidation.formValidation(legalPersonForm, {
      locale: 'sl_SI',
      localization: FormValidation.locales.sl_SI,
      fields: {
        company_signup_password: {
          validators: {
            regexp: {
              regexp: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/g,
              message: message1,
            },
          },
        },
        company_signup_confirm_password: {
          validators: {
            identical: {
              compare() {
                return legalPersonForm.querySelector('[name="company_signup_password"]').value;
              },
              message: message2,
            },
          },
        },
        company_number: {
          validators: {
            vat: {
              country: 'SI',
            },
          },
        },
      },
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        excluded: new FormValidation.plugins.Excluded(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '',
        });

        FormValidation.utils.classSet(container, {
          'is-validation-failed': !e.valid,
        });
      })
      .on('core.form.valid', () => {
        const formData = {};
        legalPersonForm.querySelectorAll('input, textarea').forEach((input) => {
          if (input.type === 'checkbox') {
            formData[input.name] = input.checked;
          } else {
            formData[input.name] = input.value.trim();
          }
        });
        axiosRegisterAction(formData);
      });

    initPostCodeHelper(fv, legalPersonForm);

    const toggleLegalHideClass = (element, toggle) => {
      element.classList.toggle('hide', toggle);
    };

    // Open company info form
    const shippingAddressCheckbox = legalPersonForm.querySelector('.company-shipping-address-checkbox input');
    const shippingAddressFields = legalPersonForm.querySelector('.company-shipping-address-fields');

    if (shippingAddressCheckbox) {
      shippingAddressCheckbox.addEventListener('change', (event) => {
        toggleLegalHideClass(shippingAddressFields, !event.currentTarget.checked);
      });
    }
  }
});
